<mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading || isLoadingFilters"></mat-progress-bar>
<div class="pre-lotes-container container-fluid" [appLoading]="isLoading || isLoadingFilters">
  <div class="row" style="line-height: 8px;">
    <div class="col-md-12 border-bottom d-flex flex-row align-items-center pb-1 pt-1" *ngIf="preLoteDetails">
      <div>
        <p class="page-title d-flex">{{preLoteDetails?.tipoAcaoDescricao}} - Pré-lote:
          #{{preLoteDetails?.preLoteId}}&nbsp;-&nbsp;<small class="d-flex">{{preLoteDetails?.descricaoStatus}}</small>
          <mat-spinner *ngIf="bloqueiaAcoes && !preLoteDetails.bFinalizado" diameter="20" color="dark"></mat-spinner>
        </p>
        <br />
        <p>
          {{preLoteDetails?.qtdItens | number}} CT-es - Gerado em
          {{preLoteDetails?.dataInclusao | date: 'dd/MM/yyyy HH:mm'}} por
          {{preLoteDetails?.usuario}} -
          <ng-container *ngIf="preLoteDetails?.nomeArquivo">Via upload ({{preLoteDetails?.nomeArquivo}})
          </ng-container>
          <ng-container *ngIf="!preLoteDetails?.nomeArquivo">Via pesquisa</ng-container>
        </p>
      </div>

      <input [disabled]="isLoadingUpload" type="file" id="fileUpload" (change)="loadFile($event)"
        accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx" hidden />

      <div class="action-bar d-flex ml-auto mb-3">
        <div class="d-flex">
          <button [hidden]="!isConfirmacao" mat-flat-button type="button" (click)="toggleConfirmacao(false)">Retomar
            edição</button>
          <button class="ml-2" mat-stroked-button type="button" *ngIf="!isConfirmacao" (click)="toggleConfirmacao(true)"
            [disabled]="bloqueiaAcoes || !obterCompletos || !habilitarEfetivacao">
            <span *ngIf="!this.obterCompletos">Nenhum registro completo para prosseguir</span>
            <span *ngIf="this.obterCompletos">Prosseguir com
              {{this.obterCompletos.quantidade}} registro(s)
              Completo(s)</span>
            &nbsp;<i class="fas fa-arrow-right"></i>
          </button>
          <button *ngIf="isConfirmacao" class="ml-2" mat-flat-button type="button" (click)="modalConfirmacaoLote()"
            [disabled]="bloqueiaAcoes || !obterCompletos || !habilitarEfetivacao " color="primary">
            <span *ngIf="!this.obterCompletos">Nenhum registro completo para prosseguir</span>
            <span *ngIf="this.obterCompletos">Processar
              {{preLoteDetails?.tipoAcaoDescricao }} de {{this.obterCompletos.quantidade}} registro(s)</span>
            &nbsp;<i class="fas fa-cogs"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-9 pr-0">
      <div class="d-flex p-2">
        <div class="d-flex">

          <p [hidden]="!isConfirmacao">Exibindo apenas os itens completos, que seguirão em sua totalidade para a
            execução da ação de {{preLoteDetails?.tipoAcaoDescricao}}</p>

          <button mat-button (click)="validarPreLote()" [hidden]="isConfirmacao" [disabled]="bloqueiaAcoes">
            <i class="fas fa-sync"></i> Revalidar
          </button>

          <button mat-button [matMenuTriggerFor]="menuRecalculo"
            [disabled]="bloqueiaAcoes || !this.obterSelecionados?.quantidade || !habilitarRecalculo"
            [hidden]="isConfirmacao || !preLoteDetails?.permiteRecalculo">
            <mat-icon>settings_backup_restore</mat-icon> Recalcular
          </button>

          <mat-menu #menuRecalculo="matMenu">
            <button mat-menu-item (click)="modalRecalcular(false)">Aplicar aos não informados</button>
            <button mat-menu-item (click)="modalRecalcular(true)">Aplicar e sobrepor</button>
          </mat-menu>

          <button mat-button [matMenuTriggerFor]="menuDeclaracao" [hidden]="isConfirmacao"
            [disabled]="bloqueiaAcoes || !this.obterSelecionados?.quantidade">
            <i class="fas fa-upload"></i> Upload da Declaração
          </button>

          <mat-menu #menuDeclaracao="matMenu">
            <button mat-menu-item (click)="uploadDeclaracao(false)">Aplicar aos não informados</button>
            <button mat-menu-item (click)="uploadDeclaracao(true)">Aplicar e sobrepor</button>
          </mat-menu>

          <input [disabled]="isLoadingUpload" type="file" id="fileUpload_geral" (change)="loadFile($event)"
            accept=".txt, .png, .jpg, .jpeg, .pdf, .doc, .docx" hidden />

        </div>
        <div class="text-right flex-grow">

          <button mat-icon-button aria-label="Limpar Filtros" (click)="clearFields()" matTooltip="Limpar Filtros">
            <i class="fas fa-eraser"></i>
          </button>

          <button mat-icon-button aria-label="Recarregar dados" (click)="paging.index = 0; loadPreLote()"
            matTooltip="Recarregar dados">
            <mat-icon>refresh</mat-icon>
          </button>

        </div>
      </div>
      <div class="table-container">
        <div class="table-responsive container-fluid no-padding">
          <table mat-table [dataSource]="grid">

            <ng-container matColumnDef="checkbox" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef class="text-center" class="checkbox" scope="col">
                <mat-checkbox color="primary" #allCheckbox (change)="selectAll($event)"
                  [checked]="this.obterSelecionados?.quantidade > 0 ? true : false"
                  [indeterminate]="this.obterNaoSelecionados?.quantidade > 0 ? true : false && this.obterSelecionados?.quantidade > 0 ? true : false"
                  [disableControl]="bloqueiaAcoes || isConfirmacao"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let grid" class="text-center" class="checkbox">
                <section class="check-section">
                  <mat-checkbox color="primary" [disableControl]="bloqueiaAcoes || !grid.bApto || isConfirmacao"
                    [indeterminate]="!grid.bApto" (change)="checkboxClick($event, grid)"
                    [checked]="grid.itemSelecionado" class="check-margin">
                  </mat-checkbox>
                </section>
              </td>
            </ng-container>

            <ng-container matColumnDef="action" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef style="background-color: white"></th>
              <td mat-cell *matCellDef="let grid">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                  [disabled]="isConfirmacao || bloqueiaAcoes">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <label [disabled]="bloqueiaAcoes" mat-menu-item color="primary" for="fileUpload_{{grid.id}}"
                    (click)="setRowData(grid)">
                    <i class="fas fa-upload cursor-pointer-icon mr-4 ml-1" style="color: #424242"></i>
                    <span>Upload Declaração</span>
                  </label>

                  <button mat-menu-item color="primary" (click)="downloadDeclaracao(grid)" *ngIf="grid.declaracaoId">
                    <mat-icon>file_download</mat-icon>
                    <span>Download Declaração</span>
                  </button>

                  <button mat-menu-item color="primary" [disabled]="bloqueiaAcoes || !habilitarRecalculo"
                    (click)="modalRecalcular(true, grid.id)" *ngIf="preLoteDetails?.permiteRecalculo">
                    <mat-icon>settings_backup_restore</mat-icon>
                    <span>Recalculo</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <!-- <mat-select formControlName="clienteId" disableOptionCentering="true" placeholder="Cliente"
                (selectionChange)="paging.index = 0; loadGrid()">
                        <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                <mat-option value="">Todos</mat-option>
                <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                  {{ cliente?.nome }}
                </mat-option>
              </mat-select> -->
                    <mat-select formControlName="clienteId" disableOptionCentering="true" placeholder="Cliente"
                      (selectionChange)="paging.index = 0; loadGrid(); listarProdutos()">
                              <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                      <mat-option value="">Todos</mat-option>
                      <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                        {{ cliente?.nome }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.clienteNome }}
              </td>
            </ng-container>

            <ng-container matColumnDef="produto">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-select [disableControl]="!clienteId || isLoading || !produtos?.length" formControlName="produtoId" disableOptionCentering="true" placeholder="Produto"
                      (selectionChange)="paging.index = 0; loadGrid()">
                      <mat-option><ngx-mat-select-search [formControl]="produtoMultiFilter" placeholderLabel="Buscar..." noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                      <mat-option value="">Todos</mat-option>
                      <mat-option *ngFor="let produto of filteredProdutos | async" [value]="produto?.produtoID">
                        {{ produto?.descricao }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.produtoDesc }}
              </td>
            </ng-container>

            <ng-container matColumnDef="filial">
              <th mat-header-cell *matHeaderCellDef>CNPJ Emissor</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.filialEmissaoDescricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="nrCTE">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>Número CT-e</mat-label>
                    <input matInput placeholder="Número CT-e" formControlName="numeroCte"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.numCTE }}
              </td>
            </ng-container>

            <ng-container matColumnDef="chaveCTE">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>Chave CT-e</mat-label>
                    <input matInput placeholder="Chave CT-e" formControlName="chaveCte"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.chaveCTE }}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_CEPRecalculo">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>CEP</mat-label>
                    <input matInput somenteNumeros maxlength="8" placeholder="CEP" formControlName="cepRecalculo"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_CEPRecalculo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_MunRecalculo">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>Município</mat-label>
                    <input matInput placeholder="Município" formControlName="munRecalculo"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_MunRecalculo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_UFRecalculo">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>UF Destino</mat-label>
                    <input matInput placeholder="UF Destino" formControlName="uFDestinoRecalculo"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_UFRecalculo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="dtEmissao">
              <th mat-header-cell *matHeaderCellDef>Dt. Autorização</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.dtEmissao | date: 'dd/MM/yyyy' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="qtdeNRT">
              <th mat-header-cell *matHeaderCellDef class="header-filter">
                <div [formGroup]="filterForm">
                  <mat-form-field class="p-1">
                    <mat-label>Qtd. Pedidos</mat-label>
                    <input matInput placeholder="Qtd. Pedidos" formControlName="qtdPedidos"
                      (change)="paging.index = 0; loadGrid()" />
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.qtdeNRT }}
              </td>
            </ng-container>

            <ng-container matColumnDef="qtdeNF">
              <th mat-header-cell *matHeaderCellDef>Qtde. NF</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.qtdeNF }}
              </td>
            </ng-container>

            <ng-container matColumnDef="tomador">
              <th mat-header-cell *matHeaderCellDef>Tomador</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.tomador }}
              </td>
            </ng-container>

            <ng-container matColumnDef="pid">
              <th mat-header-cell *matHeaderCellDef>PID</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.pid }}
              </td>
            </ng-container>

            <ng-container matColumnDef="cepDestino">
              <th mat-header-cell *matHeaderCellDef>CEP Destino</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.cepDestino }}
              </td>
            </ng-container>

            <ng-container matColumnDef="peso">
              <th mat-header-cell *matHeaderCellDef>Peso</th>
              <td mat-cell *matCellDef="let grid" (click)="visualizarPeso(grid)">
                <span class="showLink">{{ grid.peso }} </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoCte">
              <th mat-header-cell *matHeaderCellDef>Tipo CTE</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.tipoCteDescricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoProcessamento">
              <th mat-header-cell *matHeaderCellDef>Tipo Processamento</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.tipoProcessamentoDescricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="statusCancelamento">
              <th mat-header-cell *matHeaderCellDef>Status - Cancelamento</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.tipoStatusCancelamentoDescricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="valorFrete">
              <th mat-header-cell *matHeaderCellDef>Frete Peso</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.valorFrete | currency: 'BRL' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="adValorem">
              <th mat-header-cell *matHeaderCellDef>AdVal.</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.adValorem | currency: 'BRL' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="gris">
              <th mat-header-cell *matHeaderCellDef>Gris</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.gris | currency: 'BRL' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="imposto">
              <th mat-header-cell *matHeaderCellDef>Imposto</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.imposto | currency: 'BRL' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="totalFrete" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef>Total Frete</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.totalFrete | currency: 'BRL' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="statusDescricao">
              <th mat-header-cell *matHeaderCellDef>Status Descrição</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.statusDescricao }}
              </td>
            </ng-container>

            <ng-container matColumnDef="origem">
              <th mat-header-cell *matHeaderCellDef>Origem</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.origem }}
              </td>
            </ng-container>

            <ng-container matColumnDef="declaracaoNome">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let grid">
                <button *ngIf="grid.declaracaoNome" mat-icon-button aria-label="Anexo"
                  (click)="downloadDeclaracao(grid)" [matTooltip]="grid.declaracaoNome + ' clique para baixar' ">
                  <mat-icon>attach_file</mat-icon>
                </button>

                <button *ngIf="!grid.declaracaoNome" [disabled]="true" mat-icon-button aria-label="Anexo"
                  [matTooltip]="'Sem declaração vinculada!'">
                  <mat-icon>attach_file</mat-icon>
                </button>

                <label [hidden]="true" class="mat-focus-indicator mat-stroked-button mat-button-base"
                  style="background-color: rgb(236, 235, 235)" for="fileUpload_{{grid.id}}">
                  <span *ngIf="isLoadingUpload" class="d-flex align-items-center">
                    <mat-spinner diameter="20" color="dark"></mat-spinner>
                    &nbsp; Enviando
                  </span>
                  <span *ngIf="!isLoadingUpload">
                    <i class="fas fa-upload"></i> UPLOAD
                  </span>
                </label>
                <input [disabled]="isLoadingUpload" type="file" id="fileUpload_{{grid.id}}" (change)="loadFile($event)"
                  accept=".txt, .png, .jpg, .jpeg, .pdf, .doc, .docx, .zip, .rar" hidden />

              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_AliqICMS">
              <th mat-header-cell *matHeaderCellDef>Aliq. ICMS</th>
              <td mat-cell *matCellDef="let grid">
                <span *ngIf="grid.recalculoFrete_FreteTotal">{{ grid.recalculoFrete_AliqICMS }}%</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_DiferencaFreteTotal" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef>Diferença Frete Total</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_DiferencaFreteTotal | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_FretePeso">
              <th mat-header-cell *matHeaderCellDef>Frete Peso</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_FretePeso | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_FreteTotal" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef>Frete Total</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_FreteTotal | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_ValorADVALOREM">
              <th mat-header-cell *matHeaderCellDef>Valor ADVALOREM</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_ValorADVALOREM | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_ValorGris">
              <th mat-header-cell *matHeaderCellDef>Valor Gris</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_ValorGris | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_ValorICMS">
              <th mat-header-cell *matHeaderCellDef>ICMS</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_ValorICMS | currency: 'BRL'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_PID">
              <th mat-header-cell *matHeaderCellDef>PID</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_PID }}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_IdTabelaPreco">
              <th mat-header-cell *matHeaderCellDef>ID Tabela Preço</th>
              <td mat-cell *matCellDef="let grid" (click)="visualizarTabelaPreco(grid.recalculoFrete_IdTabelaPreco, grid.recalculoFrete_CEPRecalculo, grid.cepDestino)">
                <span class="showLink">{{ grid.recalculoFrete_IdTabelaPreco }} </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_PesoRecalculo">
              <th mat-header-cell *matHeaderCellDef>Peso Cálculo</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_PesoRecalculo}}
              </td>
            </ng-container>

            <ng-container matColumnDef="recalculoFrete_TipoPesoUtilizado">
              <th mat-header-cell *matHeaderCellDef>Tipo Pesagem</th>
              <td mat-cell *matCellDef="let grid">
                {{ grid.recalculoFrete_TipoPesoUtilizado }}
              </td>
            </ng-container>

            <ng-container matColumnDef="reemissao" [stickyEnd]="true">

              <th mat-header-cell *matHeaderCellDef class="text-center" class="checkbox" scope="col">
                <mat-checkbox color="primary" #allCheckbox (change)="toggleClick($event)"
                  [matTooltip]="'Emitir novos CT-es após a ação de ' + preLoteDetails?.tipoAcaoDescricao"
                  [checked]="this.obterReemissao?.quantidade && !this.obterNaoReemissao?.quantidade"
                  [indeterminate]="this.obterNaoReemissao?.quantidade > 0 ? true : false && this.obterReemissao?.quantidade > 0 ? true : false"
                  [disableControl]="isConfirmacao"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let grid" class="text-center" class="checkbox">
                <section class="check-section">
                  <mat-checkbox color="primary" [disableControl]="isConfirmacao || !grid.bApto"
                    [matTooltip]="grid.reemissao ? 'CT-e será reemitido' : 'CT-e não será reemitido'"
                    (change)="toggleClick($event, grid)" [checked]="grid.bApto && grid.reemissao" class="check-margin">
                  </mat-checkbox>
                </section>
              </td>
            </ng-container>

            <ng-container matColumnDef="statusBloqueio" [sticky]="true">
              <th mat-header-cell *matHeaderCellDef style="background-color: white"></th>
              <td mat-cell *matCellDef="let grid">
                <mat-icon *ngIf="grid.itemCompleto" class="icon-completos" matTooltip="Item completo">check</mat-icon>
                <mat-icon *ngIf="!grid.bApto" class="icon-bloqueado"
                  [matTooltip]="grid.statusBloqueio? grid.statusBloqueio:'Não validado'">
                  warning</mat-icon>
                <mat-icon *ngIf="!grid.itemCompleto && grid.bApto" class="icon-aptos"
                  matTooltip="Este item não seguirá para o lote">
                  info</mat-icon>
              </td>
            </ng-container>

            <!-- Header Dados dos CT-es Originais -->
            <ng-container matColumnDef="headers-dados-ctes-01">
              <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="8">
                Identificação do CT-e
              </th>
            </ng-container>
            <ng-container matColumnDef="headers-dados-ctes-02">
              <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="7">
                Dados da Emissão
              </th>
            </ng-container>
            <ng-container matColumnDef="headers-dados-ctes-03">
              <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="8">
                Valores
              </th>
            </ng-container>
            <!-- Header Operação -->
            <ng-container matColumnDef="headers-recalculo">
              <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="11">
                Recálculo Frete
              </th>
            </ng-container>

            <!-- Header Operação -->
            <ng-container matColumnDef="headers-operacao">
              <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="4">
                Operação
              </th>
            </ng-container>

            <ng-container matColumnDef="header-reemissao" [stickyEnd]="true">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Reemissão
              </th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="headerColumns" class="header-row"></tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let grid; columns: displayedColumns" [ngClass]="{
          'completos': grid.itemCompleto,
          'aptos': !grid.itemCompleto && grid.bApto,
          'bloqueados': !grid.bApto
        }">
            </tr>
          </table>
        </div>
        <app-paginacao *ngIf="grid?.data?.length > 0" [pageIndex]="paging?.index" [pageSize]="paging?.size"
          [length]="paging?.length" (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]">
        </app-paginacao>

        <div class="align-footer" *ngIf="grid?.data?.length > 0">
          <button mat-stroked-button type="button" (click)="downloadExcel()" [disabled]="isLoadingDownload">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="fas fa-file-excel"></i> Download Excel
            </span>
          </button>
        </div>

        <div *ngIf="grid && grid.data.length == 0" class="d-flex justify-content-center align-items-center"
          style="height: 100px;">
          Nenhum registro encontrado!
        </div>

      </div>
    </div>
    <div class="col-xl-3" [appLoading]="isLoadingFilters">
      <div>
        <form *ngIf="!this.isLoadingFilters" class="filters">
          <mat-card *ngFor="let filtro of filtros" class="card-filter-principal"
            [class]='"card-filter type-filter-"+filtro.sessaoId'>
            <mat-card-header class="header-padrao headers-cte">
              <mat-card-title class="d-flex justify-content-center align-items-center">
                <span class="session-qtd">{{filtro.quantidade | number}}</span>
                <span class="session-title"><b>{{filtro.title}}</b></span>
                <span class="session-qtd-faixa"></span>
                <mat-icon *ngIf="filtro.sessaoId == 1">info</mat-icon>
                <mat-icon *ngIf="filtro.sessaoId == 2">warning</mat-icon>
                <mat-icon *ngIf="filtro.sessaoId == 3">check</mat-icon>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div  class="pb-3">
                <div class="d-flex">
                  <mat-card *ngFor="let card of filtro.cards" class="session-card">
                    <mat-checkbox class="slide-top" [checked]="card.selecionado" (change)="refreshFilter($event, card)">
                      <mat-card-content>
                        <div class="card-qtd">{{card.quantidade | number}}</div>
                        <div class="card-title"><span>{{card.title}}</span></div>
                        <div class="card-divider"></div>
                        <div class="card-valor">{{card.totalFrete| currency: 'BRL'}}</div>
                      </mat-card-content>
                    </mat-checkbox>
                  </mat-card>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center pt-1">
                <span class="session-valor">Total do Frete: {{filtro.totalFrete | currency: 'BRL'}}</span>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>
    </div>
  </div>
</div>
